import { LogOut, type LucideIcon, type LucideProps, User } from "lucide-react";

export type Icon = LucideIcon;

export const Icons = {
  User: User,
  SignOut: LogOut,
  // Add more icons as needed
};

export type IconProps = LucideProps;
